// mui

import { Avatar, TableCell, Stack, Typography, MenuItem } from '@mui/material';

import PasswordIcon from '@mui/icons-material/Password';

// components
import GridPageAbstract from '../GridPageAbstract';
//server
import i18n from 'i18';
import ChangePassDialog from '../dialogs/ChangePassDialog';
import { ProfileCircleBulkIcon } from '../../icons-lib';
import config from '../../config';

export default class UsersPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'users';
        this.Server = this.props.context.getState().server.users;
        this.searchFields = [
            'firstName',
            'lastName',
            'email',
            'enjoyEmail',
            'merchant.name'
        ];
        this.exportButton = false;
        this.showDatePicker = true;

        this.headerStartIcon = ProfileCircleBulkIcon;
        this.bannerImage = config?.bannerImages?.users || '';

        this.exportButton = true;

        this.state.changePassDialogOpen = false;

        this.hiddenColumns = config?.hiddenColumns?.users || [];

        this.Head = [
            { id: 'email', label: 'email', ifNull: "enjoyEmail", alignRight: false, cell: 'Text', required: true },
            {
                id: 'enjoyEmail',
                label: 'enjoyEmail',
                alignRight: false,
                cell: 'Text',
                disableEditor: true
            },
            {
                id: 'language',
                label: 'language',
                alignRight: false,
                cell: 'Items',
                items: config.languages,
                filterCell: 'Items',
                filterBy: 'language',
                needTranslate: true,
                required: true
            },
            {
                id: 'roleId',
                label: 'category',
                alignRight: false,
                cell: 'SelectLabel',
                from: 'roles',
                display: 'name',
                enumType: true,
                object: 'role',
                filterCell: 'Context',
                filterBy: 'roles',
                // needTranslate: true
            },
            {
                id: 'firstName',
                label: 'firstName',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'lastName',
                label: 'lastName',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'gender',
                label: 'gender',
                alignRight: false,
                cell: 'Items',
                items: ['male', 'female'],
                filterCell: 'Items',
                filterBy: 'gender',
                needTranslate: true
            },
            {
                id: 'birthDate',
                label: 'birthDate',
                alignRight: false,
                cell: 'Date'
            },
            {
                id: 'mobilePhone',
                label: 'mobilePhone',
                alignRight: false,
                cell: 'Text'
            },
            {
                id: 'merchantsId',
                sortField: 'merchant.name',
                label: 'associatedMerchant',
                alignRight: false,
                cell: 'Associated',
                associatedSettings: { primary: 'name', secondary: 'email' },
                searchType: 'server', // server, client
                searchFields: ['name', 'email'], // for server search
                searchController: 'merchants', // for server search
                from: 'merchants',
                display: 'name',
                object: 'merchant',
                filterCell: 'Context',
                filterBy: 'merchants'
            },
            {
                id: 'partnersId',
                sortField: 'partner.name',
                label: 'associatedPartner',
                alignRight: false,
                cell: 'Associated',
                from: 'partners',
                searchType: 'server', // server, client
                searchFields: ['name', 'contactEmail'], // for server search
                searchController: 'partners', // for server search
                associatedSettings: {
                    primary: 'name',
                    secondary: 'contactEmail'
                },
                display: 'name',
                object: 'partner',
                filterCell: 'Context',
                filterBy: 'partners'
            },
            {
                id: 'isActive',
                label: 'isActive',
                alignRight: false,
                cell: 'Boolean',
                filterCell: 'Boolean',
                trueLabel: 'active',
                falseLabel: 'disabled',
                type: 'boolean',

            },
            {
                id: 'twoFactorEnabled',
                label: 'twoFactor',
                alignRight: false,
                cell: 'Boolean',
                filterCell: 'Boolean',

                trueLabel: 'enabled',
                falseLabel: 'disabled',
                type: 'boolean',
            },
            {
                id: 'emailVerified',
                label: 'emailVerified',
                alignRight: false,
                cell: 'Boolean',
                trueLabel: 'verified',
                falseLabel: 'notVerified',
                filterCell: 'Boolean',
                type: 'boolean',
            },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                hideOnAdd: true,
                readOnly: true
            },
            {
                id: 'dateModified',
                label: 'dateModified',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ].filter((item) => !this.hiddenColumns.includes(item.id));
    }

    renderAvatarCell(value) {
        return (
            <TableCell component="th" scope="row" padding="none">
                <Stack direction="row" alignItems="center" spacing={2}>
                    <Avatar alt={value} />
                    <Typography variant="subtitle2" noWrap>
                        {value}
                    </Typography>
                </Stack>
            </TableCell>
        );
    }

    renderCustomMenuItems() {
        return (
            this.allowedPermission('update') && [
                <MenuItem onClick={() => this.openChangePassDialog()} key="passUpdate">
                    <PasswordIcon sx={{ mr: 2 }} />
                    {i18n.t('buttons.changePass')}
                </MenuItem>
            ]
        );
    }

    openChangePassDialog() {
        this.setState({ changePassDialogOpen: true });
    }

    renderCustom() {
        return (
            <ChangePassDialog
                dialogOpen={this.state.changePassDialogOpen}
                userId={this.state.menuClickItemId}
                onClose={() => this.setState({ changePassDialogOpen: false })}
            />
        );
    }
}
